import { render } from "./ModalVotacionFiebreDeCanto.vue?vue&type=template&id=272fa0d6&scoped=true"
import script from "./ModalVotacionFiebreDeCanto.vue?vue&type=script&lang=js"
export * from "./ModalVotacionFiebreDeCanto.vue?vue&type=script&lang=js"

import "./ModalVotacionFiebreDeCanto.vue?vue&type=style&index=0&id=272fa0d6&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-272fa0d6"]])

export default __exports__